import { ApolloClient, HttpLink, InMemoryCache } from '@apollo/client/core/index.js';
import { usePage } from '@inertiajs/vue3';

const isNova = typeof Nova !== 'undefined';
const page = (() => {
  try { return usePage(); } catch { return null; }
})();

const currentLang =
  (isNova && Nova.config('nova_language_switcher')?.current_lang) ||
  (page?.props?.locale || page?.props?.lang || page?.props?.value?.lang) ||
  '';


const httpLink = new HttpLink({
  uri: '/graphql',
  credentials: 'include', // sessie-cookie + xsrf-cookie meesturen
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'X-Context': isNova ? 'nova' : 'app',
    ...(currentLang ? { 'X-Locale': currentLang } : {}),
  },
});

// const authLink = setContext((_, { headers }) => {
//   // const csrf = getCsrfToken();

//   return {
//     headers: {
//       ...headers,
//       Accept: 'application/json',
//       'Content-Type': 'application/json',
//       'X-Context': isNova ? 'nova' : 'app',
//       ...(currentLang ? { 'X-Locale': currentLang } : {}),
//       // ...(csrf ? { 'X-XSRF-TOKEN': csrf } : {}), // <-- vereist door 'web' middleware
//     },
//   };
// });

const apolloClient = new ApolloClient({
  link: httpLink,
  cache: new InMemoryCache(),
  devtools: {
    enabled: true
  },
});

export default apolloClient;
